import type { ReactNode } from 'react';

export const symbol_lab_panel: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-120q-24.75 0-42.37-17.63Q40-155.25 40-180v-240q0-24.75 17.63-42.38Q75.25-480 100-480h20v-163q-17-6-28.5-21.39T80-700v-80q0-24.75 17.63-42.38Q115.25-840 140-840h240q24.75 0 42.38 17.62Q440-804.75 440-780v80q0 20.22-11.5 35.61T400-643v163h160v-163q-17-6-28.5-21.39T520-700v-80q0-24.75 17.63-42.38Q555.25-840 580-840h240q24.75 0 42.38 17.62Q880-804.75 880-780v80q0 20.22-11.5 35.61T840-643v163h20q24.75 0 42.38 17.62Q920-444.75 920-420v240q0 24.75-17.62 42.37Q884.75-120 860-120H100Zm480-580h240v-80H580v80Zm-440 0h240v-80H140v80Zm480 220h160v-160H620v160Zm-440 0h160v-160H180v160Zm-80 300h760v-240H100v240Zm40-520v-80 80Zm440 0v-80 80ZM100-180v-240 240Z"
		/>
	</svg>
);
